export default __webpack_public_path__ + "static/advanced-matrix-logo-3bc13177d977af7022ffc154c3e26de9.png";